import React from "react";
import Links from './components/Links';


export function mergeLinks(linksComponents) {
  const allLinks = linksComponents
      .map(links => links.props.links)
      .reduce((flatLinks, links) => [...flatLinks, ...links], []);

    return React.createElement(Links, {links: allLinks});
}
